import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dicts: [],
      veriCodeImg:'',
      veriCodeAns:'',
      form: {
        name: '',
        email:'',
        phoneNumber: '',
        idNumber: '',
        contactAddress:'',
        title:'',
        content:'',
        
        veriCode:'',
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入电子邮箱'));
            } else {
              if (this.state.form.email !== '') {
                var pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                if (!pattern.test(this.state.form.email)) {
                  callback(new Error('请输入正确的电子邮箱格式'));
                }
              }
              callback();
            }
          }  }
        ],
        idNumber: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号'));
            } else {
              if (this.state.form.idNumber !== '') {
                var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (!pattern.test(this.state.form.idNumber)) {
                  callback(new Error('请输入正确的证件号码'));
                }
              }
              callback();
            }
          } }
        ],
        phoneNumber: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入联系电话'));
            } else {
              if (this.state.form.phoneNumber !== '') {
                var pattern = /^1[0-9]{10}$/;
                if (!pattern.test(this.state.form.phoneNumber)) {
                  callback(new Error('请输入正确的联系方式'));
                }
              }
              callback();
            }
          } }
        ],
        contactAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        veriCode: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      }
    };
  }

  componentDidMount() {
    Http.get(Request.get_dict(), {}, obj => {
      if (obj.code == 200) {
        this.setState({
          dicts: obj.data
        })
      }
    });
    Http.get(Request.getVeriCode(), {}, obj => {
      if (obj) {
        this.setState({
          veriCodeImg: obj.image,
          veriCodeAns: obj.key
        })
      }
    });
  }

  handleSubmit(e) {
    const { form,veriCodeAns } = this.state;
    e.preventDefault();
  
    this.refs.form.validate((valid) => {
      console.log('valid1111111', valid, form)
      if (form.name == '' || form.idNumber == '' || form.gender == '' || form.age == '' || form.phoneNumber == '' || form.nation == '' || form.complaintTitle == '' || form.categoryId == '' || form.complaintContent == ''||form.dept_id == ''||form.dept_name == '' || form.veriCode == '') {
        Message.error('必填项不能为空')
        return false;
      }
      if (valid) {
        Http.hdjlPost(Request.saveSoMsg(), form,form.veriCode,veriCodeAns, obj => {
          if (obj.code == 200) {
            Message.success('保存成功！');
            let form = {
              name: '',
              email:'',
              phoneNumber: '',
              idNumber: '',
              contactAddress:'',
              title:'',
              content:'',
              
              veriCode:'',
            }
            this.setState({
              form: form
            })
            this.refs.form.resetFields();
            return;
          } else {
            Message.error(obj.msg);
            return;
          }
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  handleReset(e) {
    e.preventDefault();
    let form = {
      name: '',
      email:'',
      phoneNumber: '',
      idNumber: '',
      contactAddress:'',
      title:'',
      content:'',
      
      veriCode:'',
    }
    this.setState({
      form: form
    })
    this.refs.form.resetFields();
  }
  
  onChange(key, value) {
    let form = this.state.form;
    if (key == 'dept') {
      if (value && value.value) {
        form.dept_id = value.value;
        form.dept_name = value.label;
      }
      this.setState({
        form: form
      })
    } else {
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }

  onBlur(key, e) {
    var value = e.target.value;
    if (value && value != '') {
      if (key == 'idNumber') {
        var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的证件号码');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'email') {
        var pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的电子邮箱');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'phoneNumber') {
        var pattern = /^1[0-9]{10}$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的联系方式');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }
  
  handlePreview(file) {
    console.log('preview');
  }
  
  handleRemove(file, fileList) {
    console.log('remove');
  }
  changeVCode(){
    Http.get(Request.getVeriCode(), {}, obj => {
      console.log(obj);
      if (obj) {
        this.setState({
          veriCodeImg: obj.image,
          veriCodeAns: obj.key
        })
      }
    });
  }
  render() {
    const fileList = [];
    let yzmImgStyle = {
      background: `url(${this.state.veriCodeImg}) no-repeat` 
    };
      return (
        <div className="complaint-container">
          <Form ref="form" model={this.state.form} rules={this.state.rules} labelWidth="80" className="demo-ruleForm">
            <Row gutter={8}>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="title">征求意见</span>
              </Col>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="SO_title1">欢迎您的到来！</span>
              </Col>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="SO_title2">为了更好地服务退役军人，内蒙古自治区退役军人事务厅网站开通征求意见栏目，听取大家对退役军人事务工作的意见和建议，进一步提升服务质量和工作水平。我们的工作离不开大家的宝贵意见，您的每一条意见和建议，我们都会认真汇总整理，并进行专门研究，公开答复。如果是反映个人诉求，请到【网上信访】栏目，我们会有专人负责为您解决和答复，在这里留言不作应答。</span>
              </Col>
              <Col sm={{ span: 24}} style={{marginBottom:24}}>
                <span className="SO_title3">感谢您的支持和参与，谢谢！</span>
              </Col>
              <Col sm={{ span: 24 }}>
                <Col sm={{ span: 6 }}>
                  <Form.Item label="姓名" props="name" required={true}>
                    <Input placeholder="" value={this.state.form.name} onChange={this.onChange.bind(this, 'name')} maxLength={10}></Input>
                  </Form.Item>
                </Col>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="电子邮箱" props="email" required={true}>
                  <Input placeholder="请输入电子邮箱" value={this.state.form.email} onChange={this.onChange.bind(this, 'email')} onBlur={this.onBlur.bind(this, 'email')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12 }}>
                <Form.Item label="联系电话" props="phoneNumber" required={true}>
                  <Input placeholder="请输入手机号码" value={this.state.form.phoneNumber} onChange={this.onChange.bind(this, 'phoneNumber')} onBlur={this.onBlur.bind(this, 'phoneNumber')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12}}>
                <Form.Item label="身份证号" props="idNumber" required={true}>
                  <Input placeholder="请输入18位身份证号" value={this.state.form.idNumber} onChange={this.onChange.bind(this, 'idNumber')} onBlur={this.onBlur.bind(this, 'idNumber')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 12}}>
                <Form.Item label="联系地址" props="contactAddress" required={true}>
                  <Input placeholder="请输入您的户籍地址" value={this.state.form.contactAddress} onChange={this.onChange.bind(this, 'contactAddress')} onBlur={this.onBlur.bind(this, 'contactAddress')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24}}>
                <Form.Item label="标题" props="title" required={true}>
                  <Input placeholder="标题勿超过18位汉字" value={this.state.form.title} onChange={this.onChange.bind(this, 'title')} maxLength={18}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="内容" props="content" required={true}>
                  <Input
                    type="textarea"
                    autosize={{ minRows: 10, maxRows: 20 }}
                    // rows={10}
                    resize='none'
                    value={this.state.form.content}
                    onChange={this.onChange.bind(this, 'content')}
                    placeholder="请详细描述内容"
                    maxLength={1000}
                  />
                </Form.Item>
              </Col>
              <Col sm={{ span: 24}}>
                <Form.Item label="验证码" props="veriCode" required={true} className="yzmCss">
                  <Input placeholder="" value={this.state.form.veriCode} onChange={this.onChange.bind(this, 'veriCode')} style={{width : 160}}></Input>
                  <div className="yzmImg">
                    <div style={yzmImgStyle}></div>
                  </div>
                  <span className="shuaxin" onClick={this.changeVCode.bind(this)}>刷新</span>
                </Form.Item>
              </Col>
            </Row>
            <div className="form-footer">
              <div className="form-btn" onClick={this.handleSubmit.bind(this)}>提交信息</div>
              <div className="form-btn form-btn1" onClick={this.handleReset.bind(this)}>重置信息</div>
            </div>
          </Form>
        </div>
    );
  }
}
